import React from "react"
import PropTypes from "prop-types"
import AppContainer from "@geome/react-next/lib/appContainer"
import RoutingContainer from "@geome/react-components/lib/containers/routing"
import componentIds from "@geome/shell-locator-components/lib/values/componentIds"
import AppLayout from "./appLayout"
import Resources from "./resources"
import LocationsList from "./locationsList"
import Map from "./map"
import Search from "./search"
import InfoWindow from "./infoWindow"
import Settings from "./settings"

class App extends React.Component {
  static propTypes = {
    routingHistory: PropTypes.object,
    routingRegistry: PropTypes.object,
    mapFactory: PropTypes.object,
  }

  render() {
    return (
      <AppContainer {...this.props}>
        <RoutingContainer
          history={this.props.routingHistory}
          registry={this.props.routingRegistry}
        />
        <Resources />
        <AppLayout
          renderHeader={() => <Search />}
          renderMap={() => <Map mapFactory={this.props.mapFactory} />}
          views={{
            [componentIds.INFOWINDOW]: () => <InfoWindow />,
            [componentIds.LOCATIONSLIST]: () => <LocationsList />,
            [componentIds.SETTINGS]: () => <Settings />,
          }}
        />
      </AppContainer>
    )
  }
}

export default App
